setUserProfileImagesDelete